import React from 'react'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

//import MESSAGE from '../../../business-const/Message/Message'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem3,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TextValidatorText,
    TextValidatorNumberRequired,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

//import {
//    RichTextEditor
//} from '../../../business-components/RichTextEditor/RichTextEditor'

import {
    RichTextEditorPadrao
} from '../../../business-components/RichTextEditor/RichTextEditorPadrao'

import tipoItemPaginaList from '../../../business-rules/List/tipoItemPaginaList'

import {
    IconButtonHelp,
    IconButtonClearEntradaDados,
    IconButtonMoveParaCimaParaBaixo,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import reportList from '../../../business-rules/List/reportList'

import {
    incrementaContPaginaAdicionalItemPagina,
} from './EstudoServicePaginaAdicionalItemPagina'



const ConfiguracaoFormPaginaConfiguracao = ({ values, ind, handleChange, setFieldValue }) => {

    return (
        <GridContainer>
            <GridItem12>
                <FieldArray name={`paginaAdicional[${ind}].itemPagina`}>
                    {(arrayHelpers) => (
                        <DivForm>
                            <DivForm>
                                {values.paginaAdicional[ind].itemPagina?.map((itemPagina, indItemPagina) => {
                                    return (
                                        <GridContainer
                                            key={ind}
                                        >
                                            <GridItem12>
                                                <GridContainer>
                                                    <GridItem3>
                                                        <TextFieldTextSelect
                                                            name={`paginaAdicional[${ind}].itemPagina[${indItemPagina}].tipoItemPagina`}
                                                            label={LABEL.tipoItemPagina}
                                                            value={itemPagina.tipoItemPagina || ''}
                                                            onChange={handleChange}
                                                            list={tipoItemPaginaList}
                                                        />
                                                    </GridItem3>

                                                    <GridItem1>
                                                        {(itemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaTextoImagemVariavel ||
                                                        itemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaHTMLVariavel) && (
                                                            <IconButtonHelp
                                                                helpTitle={LABEL.variaveis}
                                                                helpText={HELPTEXT.tipoItemPaginaTextoHtmlVariavel}
                                                            />
                                                        )}
                                                        
                                                        {(itemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaTextoImagemContasInvestimentos ||
                                                        itemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaHTMLContasInvestimentos) && (
                                                            <IconButtonHelp
                                                                helpTitle={LABEL.contasInvestimentos}
                                                                helpText={HELPTEXT.tipoItemPaginaTextoHtmlContasInvestimentos}
                                                            />
                                                        )}
                                                    </GridItem1>

                                                    <GridItem2>
                                                        <TextValidatorNumberRequired
                                                            name={`paginaAdicional[${ind}].itemPagina[${indItemPagina}].margemTop`}
                                                            label={LABEL.margemTop}
                                                            value={itemPagina.margemTop === 0 ? 0 : itemPagina.margemTop || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.margemTop}
                                                            numMax={NUMMAX.margemTop}
                                                        />
                                                    </GridItem2>
                                                    
                                                    <GridItem2>
                                                        <TextValidatorNumberRequired
                                                            name={`paginaAdicional[${ind}].itemPagina[${indItemPagina}].margemLeft`}
                                                            label={LABEL.margemLeft}
                                                            value={itemPagina.margemLeft === 0 ?  0 : itemPagina.margemLeft || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.margemLeft}
                                                            numMax={NUMMAX.margemLeft}
                                                        />
                                                    </GridItem2>
                                                    
                                                    <GridItem2/>

                                                    <GridItem1
                                                        align='right'
                                                    >
                                                        <IconButtonMoveParaCimaParaBaixo
                                                            className='mt-3'
                                                            array={values.paginaAdicional[ind].itemPagina}
                                                            nomeArray={`paginaAdicional[${ind}].itemPagina`}
                                                            setFieldValue={setFieldValue}
                                                            ind={indItemPagina}
                                                        />
                                                    </GridItem1>

                                                    <GridItem1
                                                        className='mt-1'
                                                    >
                                                        <IconButtonClearEntradaDados
                                                            type="submit"
                                                            onClick={() =>
                                                                arrayHelpers.remove(indItemPagina)
                                                            }
                                                        />
                                                    </GridItem1>
                                                </GridContainer>

                                                <GridContainer>
                                                    <GridItem11>
                                                        {(itemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaTextoImagem ||
                                                        itemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaTextoImagemVariavel ||
                                                        itemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaTextoImagemContasInvestimentos) && (
                                                            <>
                                                                {/*
                                                                <RichTextEditor
                                                                    content={itemPagina.richText}
                                                                    paginaInteira={values.paginaAdicional[ind].paginaInteira}
                                                                    handleContentChange={(content) =>
                                                                        setFieldValue(
                                                                            `paginaAdicional[${ind}].itemPagina[${indItemPagina}].richText`,
                                                                            content
                                                                        )
                                                                    }
                                                                />
                                                                */}
                                                                <RichTextEditorPadrao
                                                                    name={`paginaAdicional[${ind}].itemPagina[${indItemPagina}].richText`}
                                                                    content={itemPagina.richText}
                                                                    paginaInteira={values.paginaAdicional[ind].paginaInteira}
                                                                    setFieldValue={setFieldValue}
                                                                />

                                                                {/*
                                                                <h6
                                                                    className='text-muted mt-4 mb-4'
                                                                >
                                                                    {values.paginaAdicional[ind].paginaInteira
                                                                        ?
                                                                            MESSAGE().formatoMaximoImagemPaginaPaginaAdicionalPaginaInteira
                                                                        :
                                                                            MESSAGE().formatoMaximoImagemPaginaPaginaAdicional
                                                                    }
                                                                </h6>
                                                                */}
                                                            </>
                                                        )}

                                                        {(itemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaHTML ||
                                                        itemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaHTMLVariavel ||
                                                        itemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaHTMLContasInvestimentos) && (
                                                            <TextValidatorText
                                                                name={`paginaAdicional[${ind}].itemPagina[${indItemPagina}].html`}
                                                                label={LABEL.html}
                                                                value={itemPagina.html || ''}
                                                                onChange={handleChange}
                                                                tamMax={TAMMAX.html}
                                                                notToUpperCase={true}
                                                            />
                                                        )}

                                                        {itemPagina.tipoItemPagina === HARDCODE.idTipoItemPaginaGraficoTabela && (
                                                            <TextFieldTextSelect
                                                                name={`paginaAdicional[${ind}].itemPagina[${indItemPagina}].graficoTabela`}
                                                                label={LABEL.graficoTabela}
                                                                value={itemPagina.graficoTabela || ''}
                                                                onChange={handleChange}
                                                                list={reportList(values.idFormList, null, true, null, null)}
                                                            />
                                                        )}
                                                    </GridItem11>
                                                </GridContainer>
                                            </GridItem12>
                                        </GridContainer>
                                    )
                                })}
                            </DivForm>

                            <GridContainer>
                                <ButtonIncluirLinha
                                    label={LABEL.buttonIncluirItemPagina} 
                                    onClick={() => 
                                        {
                                            incrementaContPaginaAdicionalItemPagina(values, ind)

                                            arrayHelpers.push({
                                                id: values.paginaAdicional[ind].contItemPagina,
                                                margemTop: 0,
                                                margemLeft: 0,
                                            })
                                        }
                                    }
                                />
                            </GridContainer>
                        </DivForm>
                    )}
                </FieldArray>
            </GridItem12>
        </GridContainer>
    )
}

export default ConfiguracaoFormPaginaConfiguracao